<template>
  <div class="course-card" style="border:1px solid #ffb580">
    <h2>{{ courseInfo.name }}</h2>
    <div class="times">
      <span>开课时间&nbsp;{{ courseInfo.courseBeginTime.slice(0, 11) }}</span
      ><span>课时&nbsp;{{ courseInfo.classPeriod }}</span
      ><span class="num">已领</span><b>{{ courseInfo.salesVolume }}</b>
    </div>
    <ul class="teacher" v-if="courseInfo.teacherRespVOS">
      <li
        v-for="(teacherItem, teaind) in courseInfo.teacherRespVOS.length > 3
          ? courseInfo.teacherRespVOS.slice(0, 3)
          : courseInfo.teacherRespVOS"
        :key="teaind"
      >
        <img :src="teacherItem.teacherHead" alt="" />
        <p>{{ teacherItem.name }}</p>
      </li>
    </ul>
    <button
      class="btn"
      :class="{ active: !courseInfo.flag && receiveStatus }"
      @click="toReceive(courseInfo)"
    >
      {{ courseInfo.flag ? '已领取' : receiveStatus ? '不可领取' : '领取' }}
    </button>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
    receiveStatus: {
      type: Boolean,
      default: false,
    },
  },

  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    toReceive(data) {
      if (this.receiveStatus) return;
      this.$emit('sendReceive', { item: data, type: 1 });
    },
    toPay() {
      const query = [
        {
          productId: this.courseId,
          skuId: this.productSku.productSkuId,
        },
      ];
      const { liveRoomId } = this.$route.query;
      if (!this.$root.$data.isApp) {
        this.$router.push({
          path: '/payOrder',
          query: { product: JSON.stringify(query), liveRoomId },
        });
      } else {
        // eslint-disable-next-line no-lonely-if
        this.$sendToApp('buyCourseNew', { product: JSON.stringify(query), liveRoomId }, false);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.course-card {
  position: relative;
  width: 590px;
  min-height: 220px;
  margin: 0 auto 24px;
  padding: 24px;
  // border: 1px solid #ffb580;
  border-radius: 8px;
  > h2 {
    display: -webkit-box;
    margin-bottom: 8px;
    color: #333;
    font-weight: 500;
    font-size: 32px;
    line-height: 35px;
    @extend .ellipsis-2;
  }
  .times {
    padding-bottom: 24px;
    span {
      margin-right: 20px;
      color: #a5a5a5;
      font-size: 24px;
    }
    span.num {
      margin-right: 5px;
    }
    b {
      color: #ff6c02;
      font-weight: 300;
      font-size: 24px;
    }
  }
}
.teacher {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  li {
    margin-right: 28px;
    img {
      display: block;
      width: 70px;
      height: 70px;
      margin: 0 auto;
      border-radius: 50%;
    }
    p {
      width: 100px;
      padding-top: 16px;
      overflow: hidden;
      color: #a5a5a5;
      font-size: 22px;
      white-space: nowrap;
      text-align: center;
      text-overflow: ellipsis;
    }
  }
}
.btn {
  position: absolute;
  right: 24px;
  bottom: 24px;
  min-width: 120px;
  height: 48px;
  color: #fff;
  font-size: 24px;
  line-height: 48px;
  text-align: center;
  background: #ff6c02;
  border-radius: 32px;
}
.btn.active {
  color: #eee;
  background: #a5a5a5;
}
</style>
